window.newuni = function() {
    var selection = document.getElementById('university_visit_university').value;
    var newUniInput = document.getElementById('newuni');
    if (selection == "New...") {
        alert("Please enter the name of the new university as you would like it to appear in the list of available universities.");
        newUniInput.style.display = "block";
    } else {
        newUniInput.style.display = "none";
    }
}
